import React from "react";
import CrudPage from "@/components/CrudPage";
import { Badge } from "@/components/Common";

export default function Aziende() {
  return (
    <CrudPage
      title="Aziende"
      subtitle="Anagrafiche clienti, sedi e referenti"
      endpoint="aziende"
      testid="aziende-page"
      allegati
      columns={[
        { key: "denominazione", label: "Denominazione", render: (r) => <span className="font-medium text-slate-900">{r.denominazione}</span> },
        { key: "piva", label: "P.IVA", render: (r) => <span className="font-mono text-xs">{r.piva || "—"}</span> },
        { key: "sede", label: "Comune", render: (r) => r.sede_legale?.comune || "—" },
        { key: "sedi", label: "Sedi", render: (r) => <Badge label={`${(r.sedi || []).length} sedi`} cls="bg-slate-100 text-slate-600 border-slate-200" /> },
        { key: "referenti", label: "Referenti", render: (r) => (r.referenti || []).length },
      ]}
      fields={[
        { name: "denominazione", label: "Denominazione", type: "text", full: true },
        { name: "piva", label: "Partita IVA", type: "text" },
        { name: "cf", label: "Codice Fiscale", type: "text" },
        { name: "sl_via", label: "Sede legale - Via", type: "text" },
        { name: "sl_cap", label: "Sede legale - CAP", type: "text" },
        { name: "sl_comune", label: "Sede legale - Comune", type: "text" },
        { name: "sl_telefono", label: "Sede legale - Telefono", type: "text" },
        { name: "sl_mail", label: "Sede legale - Mail", type: "text" },
        { name: "pec", label: "PEC", type: "text" },
        { name: "sdi", label: "Codice SDI", type: "text" },
        { name: "legale_rappresentante", label: "Legale Rappresentante", type: "text" },
        { name: "sl_referente", label: "Referente", type: "text" },
        { name: "so1_denominazione", label: "Sede operativa 1 - Denominazione", type: "text" },
        { name: "so1_via", label: "Sede operativa 1 - Via", type: "text" },
        { name: "so1_cap", label: "Sede operativa 1 - CAP", type: "text" },
        { name: "so1_comune", label: "Sede operativa 1 - Comune", type: "text" },
        { name: "so1_telefono", label: "Sede operativa 1 - Telefono", type: "text" },
        { name: "so1_mail", label: "Sede operativa 1 - Mail", type: "text" },
        { name: "so1_referente", label: "Sede operativa 1 - Referente", type: "text" },
        { name: "so2_denominazione", label: "Sede operativa 2 - Denominazione", type: "text" },
        { name: "so2_via", label: "Sede operativa 2 - Via", type: "text" },
        { name: "so2_cap", label: "Sede operativa 2 - CAP", type: "text" },
        { name: "so2_comune", label: "Sede operativa 2 - Comune", type: "text" },
        { name: "so2_telefono", label: "Sede operativa 2 - Telefono", type: "text" },
        { name: "so2_mail", label: "Sede operativa 2 - Mail", type: "text" },
        { name: "so2_referente", label: "Sede operativa 2 - Referente", type: "text" },
        { name: "note", label: "Note", type: "textarea", full: true },
      ]}
    />
  );
}
